import request from '../utils/request.js'

export default {
	getList(params) {
		return request.post(`zuowei/lists`, params).then(res => res.data);
	},
	add(params) {
		return request.post(`zuowei/add`, params).then(res => res.data);
	},
	edit(params) {
		return request.post(`zuowei/add`, params).then(res => res.data);
	},
	details(params) {
		return request.post(`zuowei/details`, params).then(res => res.data);
	},
	delete(params) {
		return request.post(`zuowei/del`, params).then(res => res.data);
	},
	selectList(params) {
		return request.post(`zuowei/selectlist`, params).then(res => res.data);
	},
  	anpai(params) {
		return request.post(`zuowei/anpai`, params).then(res => res.data);
	},
  	zuoweibiao(params) {
		return request.post(`zuowei/export_zuoweibiao`, params).then(res => res.data);
	},
  	zuoweibiao_pl(params) {
		return request.post(`zuowei/export_zuoweibiao_pl`, params).then(res => res.data);
	},
  	zhuotie(params) {
		return request.post(`zuowei/export_zhuotie`, params).then(res => res.data);
	},
  	zhuotie_pl(params) {
		return request.post(`zuowei/export_zhuotie_pls`, params).then(res => res.data);
	},
  	generateSeat(params) {
		return request.post(`kaochang/make_seat`, params).then(res => res.data);
	},
	sourceLists(params) {
		return request.post(`zuowei/source_lists`, params).then(res => res.data);
	},
	exportSourceTemplate(params) {
		return request.post(`zuowei/export_source_template`, params).then(res => res.data);
	},
	
    uploadAchievement(params) {
		return request.upload(`zuowei/upload_achievement`, params).then(res => res.data);
	},
	




}



// WEBPACK FOOTER //
// ./src/api/zuowei.js